export const fuzzyMatchOptions = {
    includeScore : true,
    threshold : 0.4,
    keys : ['value', 'text'],
};

export const fuseOptions = (keys, threshold=0.4) => {
    return {
        threshold,
        keys,
    };
};
